import type { IndividualsFilters } from "./table";

export const defaultFilters: IndividualsFilters = {
  createdAtStart: "",
  createdAtEnd: "",
  releasedAtStart: "",
  releasedAtEnd: "",
  taxonomicGroupId: "",
  situation: "",
  sortOrder: "",
  individual: "",
};
